<template>
    
    <div class="ad_loader">
        <div class="ad_loader__spinner">
            <Spinner></Spinner>
        </div>
    </div>

</template>

<script>
import Spinner from '@/components/spinner/Spinner.vue'

export default {    

    components: {
        Spinner
    }
}
</script>

<style scoped>

.ad_loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background-color: rgba(255, 255, 255, 0.5);
}

.ad_loader .ad_loader__spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0.6);
}

</style>